import React from 'react'
import { Box, ListItem, Text } from '@domain-group/suit-theme'

import styles from './styles.module.scss'

interface ItemProps {
  callbacks: {
    createOrEditTaskListItem: () => void,
  },
  children: React.ReactNode,
  icon: React.ReactNode,
  label: string,
}

const Item = (props: ItemProps) => {
  const {
    callbacks: { createOrEditTaskListItem }, children, icon, label,
  } = props

  return (
    <Box className={styles.root}>
      <ListItem
        boxProps={{
          alignItems: 'center',
          as: 'a',
          padding: 'large',
        }}
        onClick={() => createOrEditTaskListItem()}
        showAngleIcon
      >
        {icon && (
          <Box color="lightGrey" marginRight="large" width="auto">
            {icon}
          </Box>
        )}

        <Box flexDirection="column">
          <Text color="bodyFontLightColor" fontSize="xsmall" marginBottom="small">
            {label}
          </Text>

          <Text fontSize="medium">
            {children}
          </Text>
        </Box>
      </ListItem>
    </Box>
  )
}

export default Item
